// extracted by mini-css-extract-plugin
export default {"Tag":"XG9V5tSm"};